import { hooks, mui, React, ts, ui } from '_core';

import { DraftParams } from './types';

type FormProps = {
  params: DraftParams;
  setParams: (_p: DraftParams) => void;
  hasBenchmark: boolean;
};

const Form = ({ params, setParams, hasBenchmark }: FormProps) => {
  const [benchmark, setBenchmark] = React.useState(params.benchmark || null);
  const [withBenchmark, setWithBenchmark] = React.useState(params.with_benchmark || false);
  const [showTargetWeight, setShowTargetWeight] = React.useState(params.showTargetWeight || false);
  const uiStyles = hooks.useUiStyles();

  React.useEffect(() => {
    const data = {
      ...params,
      with_benchmark: withBenchmark,
      showTargetWeight: showTargetWeight,
    } as DraftParams;

    if (withBenchmark) data.benchmark = benchmark;
    else if (data.benchmark) delete data.benchmark;

    setParams(data);
  }, [withBenchmark, benchmark, showTargetWeight]);

  if (!hasBenchmark) return null;

  return (
    <mui.core.Box sx={uiStyles.widgetEditMode}>
      <mui.core.Box mt={2}>
        <mui.core.FormControlLabel
          control={
            <mui.core.Switch size="small" checked={withBenchmark} onChange={() => setWithBenchmark(!withBenchmark)} />
          }
          label="Has benchmark"
        />
      </mui.core.Box>

      {params.isBasket && (
        <mui.core.Box mt={3}>
          <mui.core.FormControlLabel
            control={
              <mui.core.Switch
                size="small"
                checked={showTargetWeight}
                onChange={() => setShowTargetWeight(!showTargetWeight)}
              />
            }
            label="Show target weight returns"
          />
        </mui.core.Box>
      )}

      {withBenchmark && (
        <mui.core.Box mt={2}>
          <ui.Benchmark
            value={benchmark || undefined}
            setValue={setBenchmark}
            universeContextPath={'$universe.handle'}
            hiddenOptions={[ts.enums.BENCHMARK_TYPES_ENUM.DS_INDEX]}
            universeIdPath="universe_id"
          />
        </mui.core.Box>
      )}
    </mui.core.Box>
  );
};

export default Form;
